module.exports = __webpack_public_path__ + "img/pmh.e1e52895.jpg";